import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
import { TRANSITION_SETTINGS } from '../config';
export const GapFix = styled.div `
  flex-shrink: 0;
  height: 0;
  width: 100%;
`;
export const SidebarMenuCollapsibleChildrenContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${themeGet('spacing.sm')};
  overflow: hidden;
  opacity: 0;
  max-height: 0;
  transition: all ${TRANSITION_SETTINGS};

  ${(props) => props.$open &&
    `
    opacity: 1;
  `}
`;
